export default __webpack_public_path__ + "static/media/airplane-seat.31e262c4.svg";